import { type OfferV11 } from '@redteclab/api/clients/bully'

import { useGlobalConfigContext } from '../../../global-config'
import { offerAccessorIsLastThirtyDaysPriceEnabled } from '../../model/offerAccessor/offerAccessorIsLastThirtyDaysPriceEnabled'

export const useShowProductThirtyDaysPrice = (offer?: OfferV11): boolean => {
  const { tenant } = useGlobalConfigContext()

  return offerAccessorIsLastThirtyDaysPriceEnabled(offer, tenant)
}
